<template>
  <div class="flex flex-row justify-center w-full">
    <div class="form-page form-2">
        <div id="root2">
            <sc-text v-if="fields.holdingMessage"
                     tag="p"
                     class="text-lg p-10 text-center"
                     :field="fields.holdingMessage" />
        </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import { Text } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'EntryForm2',
  components: {
    ScText: Text,
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    onMounted(() => {
      if (!props.fields?.holdingMessage?.value?.trim()) {
        const rewardsWidget = document.createElement('script');
        rewardsWidget.setAttribute(
          'src',
          'https://assets-emea.rewards.heineken.com/libs/widget/3.4.3/RewardsWidget.3.4.3.js'
        );

        // Wait for the script to load before initializing the widget
        rewardsWidget.onload = () => {
          // eslint-disable-next-line no-undef
          new Rewards.RewardsWidget({
            campaignId: 'fdc89ae6-c8a9-433b-aefe-e2dc6ec947d6',
            apiUrl: 'https://api-emea.rewards.heineken.com/rewards-hint',
            previewToken: 'fdc5e9e85ee384a372bc2fa1a0def026887f2f07',
            apiKey: '536e5109ad1b4d939f3ae23354da634b',
            selector: '#root2',
          });
        };

        document.head.appendChild(rewardsWidget);
      }
    });
  },
};
</script>
<style>
@import url('https://assets-emea.rewards.heineken.com/cms/brandstyles/Fosters/styles.css');
</style>
